import { ChackImageIsFile } from "src/helper/publicFunction";
import { GetFunction, PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetChat =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.chat.get_chat;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        is_client: true,
      });
      console.log({ responseresponse: response });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const GetChatMessages =
  ({ callback, chat_id, offset = 1, limit = 50 }) =>
  async (dispatch, getState) => {
    try {
      const queryParams = [`chat_id=${chat_id}`];

      if (typeof offset !== "undefined") {
        queryParams.push(`offset=${offset}`);
      }

      if (typeof limit !== "undefined") {
        queryParams.push(`limit=${limit}`);
      }

      const link = `${UrlApi.chat.get_chat_messages}?${queryParams.join("&")}`;

      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        is_client: true,
      });

      callback(response);
    } catch (err) {
      console.log({ err });
      callback(false);
    }
  };

export const UploadFileMessage =
  ({ callback, file }) =>
  async (dispatch, getState) => {
    try {
      var bodyFormData = new FormData();

      if (
        file &&
        file != null &&
        file != undefined &&
        ChackImageIsFile({ data: file, IsBoolean: true })
      ) {
        bodyFormData.append("file", file);
      } else if (!file) {
        bodyFormData.append("file", "");
      }
      const response = await PostFunction({
        data: bodyFormData,
        Route: UrlApi.chat.upload,
        showalert: false,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        is_client: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };
